import { render, staticRenderFns } from "./DaylyOrderStatistic.vue?vue&type=template&id=13413eb6&scoped=true&"
import script from "./DaylyOrderStatistic.vue?vue&type=script&lang=js&"
export * from "./DaylyOrderStatistic.vue?vue&type=script&lang=js&"
import style0 from "./DaylyOrderStatistic.vue?vue&type=style&index=0&id=13413eb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13413eb6",
  null
  
)

export default component.exports